class ctxDatapickerDirective {
    constructor() {
        this.restrict = 'A';
    }

    link(scope, element, attrs) {
        element.find('input').datetimepicker({
            locale: attrs.ctxDatepicker || 'en'
        });
    }

    static directiveFactory() {
        return new ctxDatapickerDirective();
    }
}

module.exports = ctxDatapickerDirective.directiveFactory;


// WEBPACK FOOTER //
// ./src/shared/ctxDatepicker/ctxDatepicker.directive.js